var NAME_TYPE = 'Name must be a string';
var NAME_BLANK = 'Name can not be blank';
var NAME_INVALID = 'Invalid browser name';
var VARIANT_TYPE = 'Variant must be a string';
var VARIANT_INVALID = 'Invalid browser variant';
var BROWSER_TYPE = 'Must be a Browser entity';
export { NAME_TYPE, NAME_BLANK, NAME_INVALID, VARIANT_TYPE, VARIANT_INVALID, BROWSER_TYPE };